/**
 * @fileoverview Shared NoteTag schema used by both frontend and backend.
 * Junction table linking notes to tags.
 */

import { z } from 'zod';
import { commonValidators, createCrudSchemas, createEntityIdSchema, createdAtSchema, deletedAtSchema, getSchemaFields, updatedAtSchema } from './base.js';
import { ID_PATTERNS } from './types.js';

/**
 * NoteTag validation schema (junction table)
 */
export const NoteTagSchema = z.object({
  id: createEntityIdSchema(ID_PATTERNS.NOTE_TAG, 'ID must be in note_tag nanoid7 format (nt + digit 2-9 + 4 alphanumeric)'),
  note_id: commonValidators.noteForeignKey('Note ID'),
  tag_id: commonValidators.foreignKey('Tag ID'),
  metadata: commonValidators.jsonField('Metadata'),
  deleted_at: deletedAtSchema,
  created_at: createdAtSchema,
  updated_at: updatedAtSchema,
});

const { CreateSchema, UpdateSchema } = createCrudSchemas(NoteTagSchema);

export const NoteTagCreateSchema = CreateSchema;
export const NoteTagUpdateSchema = UpdateSchema;

export type NoteTag = z.infer<typeof NoteTagSchema>;
export type NoteTagCreate = z.infer<typeof NoteTagCreateSchema>;
export type NoteTagUpdate = z.infer<typeof NoteTagUpdateSchema>;

export const NOTE_TAG_FIELDS = getSchemaFields(NoteTagSchema);
